import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKCARTFUNNELRADIOITEMBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "required",
  { type: 'separator' },
  "text_color",
  "button_color",
  { type: 'separator' },
  "active_text_color",
  "active_button_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskCartFunnelRadioItemBlockDescriptor: _generatedKioskCartFunnelRadioItemBlockDescriptor,
  kioskCartFunnelRadioItemBlockBlocDefinition,
  kioskCartFunnelRadioItemBlockDashboardLayout,
  kioskCartFunnelRadioItemBlockConfig,
  kioskCartFunnelRadioItemBlockResolveConfig,
  kioskCartFunnelRadioItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk Cart funnel / Choices input",
    componentType: 'KioskCartFunnelRadioItemBlockComponent',
    category: 'kiosk',
    description: "Kiosk Cart funnel / Choices input.",
    keywords: [],
    allowedIn: [
      { bloc: "KioskCartFunnelFormBlockComponent", slot: "items" },
    ],
    sharedFields: {}
,
    slots: [
      {
        key: 'options',
        name: "pages.blocks.kiosk-cart-funnel-radio-item.options.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskCartFunnelRadioOptionBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-funnel-radio-item.title.label",
        help: "pages.blocks.kiosk-cart-funnel-radio-item.title.help",
      }
    }),
    required: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.kiosk-cart-funnel-radio-item.required.label",
      }
    }),
    display_title_in_comment: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.kiosk-cart-funnel-radio-item.display-title-in-comment.label",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-900"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-radio-item.text-color.label",
      }
    }),
    button_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-radio-item.button-color.label",
      }
    }),
    active_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-radio-item.active-text-color.label",
      }
    }),
    active_button_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-900"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-radio-item.active-button-color.label",
      }
    })
  }),

  () => ({
    omitFields: ["display_title_in_comment"] as const,
    tabs: [
      {
        label: "pages.blocks.kiosk-cart-funnel-radio-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-cart-funnel-radio-item.fieldset.field.label",
            fields: ["title", "required", "options"],
          },
          {
            legend: "pages.blocks.kiosk-cart-funnel-radio-item.fieldset.choice.label",
            fields: ["text_color", "button_color"],
          },
          {
            legend: "pages.blocks.kiosk-cart-funnel-radio-item.fieldset.selected-choice.label",
            fields: ["active_text_color", "active_button_color"],
          },
        ],
      },
    ],
  })
);

export function kioskCartFunnelRadioItemBlockDescriptor(): IBlockDescriptor;
export function kioskCartFunnelRadioItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskCartFunnelRadioItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskCartFunnelRadioItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskCartFunnelRadioItemBlockDescriptor, kioskCartFunnelRadioItemBlockProperties, fieldOrder);
}

export {
  kioskCartFunnelRadioItemBlockBlocDefinition,
  kioskCartFunnelRadioItemBlockDashboardLayout,
  kioskCartFunnelRadioItemBlockProperties,
  kioskCartFunnelRadioItemBlockConfig,
  kioskCartFunnelRadioItemBlockResolveConfig,
};

export type KioskCartFunnelRadioItemBlockConfig = typeof kioskCartFunnelRadioItemBlockConfig;
